import { generateClient } from "aws-amplify/api";
import { uploadData, remove as removeS3Asset } from 'aws-amplify/storage';
import { createAsset, updateAsset, deleteAsset as removeAsset } from "graphql/customs/mutations";
import { getAsset as fetchPoBox, listAssets } from "graphql/queries";
import { cleanUpData, getDataFromResponse, getNotDeletedItems } from "utils/Api";
import { nanoid } from 'nanoid';

const API = generateClient();

export const saveAsset = async (data, s3PathPrefix) => {
    const operationName = (data && data.id) ? "update" : "create";
    const operation = operationName === "update" ? updateAsset : createAsset;

    if (data._toDelete) {
        const deleteAssetResponse = await deleteAsset(data, data.path);
        return deleteAssetResponse;
    }

    let cleanData = cleanUpData(data);
    if (operationName === "create") {
        const s3FilePath = await uploadFileToS3(data, s3PathPrefix);
        cleanData["path"] = s3FilePath;
    }
    delete cleanData["data"];
    delete cleanData["filePondData"];

    const saveResponse = await API.graphql({
        query: operation,
        variables: {
            "input": cleanData
        }
    });
    return getDataFromResponse(saveResponse, operationName === "create" ? "createAsset" : "updateAsset");
};

const uploadFileToS3 = async (file, s3PathPrefix = "") => {
    const s3AssetPrefixId = nanoid(10);
    const fileName = s3PathPrefix + s3AssetPrefixId + "-" + file.name;
    const operation = uploadData({
        path: fileName,
        data: file.data,
        options: {
            contentType: file.type,
        }
    });
    await operation.result;
    return fileName;
}

const deleteFileToS3 = async (s3Path) => {
    await removeS3Asset({
        path: s3Path,
    });
}

export const getAssets = async (filter = {}) => {
    const data = await API.graphql({
        query: listAssets,
        variables: {
            "filter": filter
        }
    })
    return getNotDeletedItems(data, "listAssets");
}

export const getAsset = async (assetId) => {
    let assetObject = await API.graphql({
        query: fetchPoBox,
        variables: {
            id: assetId
        }
    });
    return getDataFromResponse(assetObject, "getAsset");
}

export const deleteAsset = async (asset, filePath) => {
    const deletedAsset = await API.graphql({
        query: removeAsset,
        variables: {
            input: {
                "id": asset.id,
            }
        }
    });
    if (filePath) {
        await deleteFileToS3(filePath);
    }
    return getDataFromResponse(deletedAsset, "deleteAsset");

}